/**
 * 「上传卡死」判死阈值：前端列表页兜底与后端 upload_watchdog 必须同一口径。
 * 后端对应实现见 bsp_back/apps/packages/upload_state.py::stuck_threshold_seconds。
 *
 * 旧口径按 0.5MB/s 估算上传总时长（5GB 文件要 2h44m 才判死），断流后会长时间
 * 挂在"上传中"既不动也不报错，用户无从判断。改为按「多久没有进展」判死。
 */

const MINUTE = 60 * 1000;

/** 正在上传且有分片已落盘：15 分钟无进展即判死 */
export const STUCK_THRESHOLD_UPLOADING_MS = 15 * MINUTE;
/** 状态为 uploading 但一个分片都还没成功落盘：30 分钟 */
export const STUCK_THRESHOLD_NO_PENDING_KEY_MS = 30 * MINUTE;
/** 排队中（等上传槽 / 等 bot）：60 分钟，避免误杀正常排队的文件 */
export const STUCK_THRESHOLD_QUEUED_MS = 60 * MINUTE;

export interface StuckThresholdInput {
  status?: string | null;
  /** 后端返回的 pending_object_key，非空说明至少有一个分片已落盘 */
  pendingObjectKey?: string | null;
}

export const getStuckThresholdMs = ({ status, pendingObjectKey }: StuckThresholdInput): number => {
  if (status === 'queued') return STUCK_THRESHOLD_QUEUED_MS;
  if (!pendingObjectKey) return STUCK_THRESHOLD_NO_PENDING_KEY_MS;
  return STUCK_THRESHOLD_UPLOADING_MS;
};
